export default __webpack_public_path__ + "static/media/About_B.a3e73aaf.png";